// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_HiN","cls2":"UpsellModalRedesign-cls2_Q47 UpsellModalRedesign-cls1_HiN","primary":"UpsellModalRedesign-primary_fJM"};